<ngx-spinner></ngx-spinner>
<section id="front_wrap">
  <div class="auth-language-selector"><app-language-selector></app-language-selector></div>
  <section id="connect_page">
    <div id="connect_title">
      <p>{{'auth.newPassword' | translate}}</p>
    </div>
    <div id="connect_content">
      <form>
        <input type="email">
        <input type="password" [placeholder]="'auth.newPassword' | translate" [(ngModel)]="new_password" [ngModelOptions]="{standalone: true}">

        <button class="blue_btn" type="button" color="accent" (click)="change_password()">{{'common.change' | translate}}</button>
        <p style="margin-top: 25px"><a href="/">&lt;&lt; {{'auth.login' | translate}}</a></p>
      </form>
    </div>
    <div id="connect_legal">
      <ng-container *ngIf="entityType == 'EKAMPUS'">
        <p>CertiKap - par <strong>Kaptitude</strong> - 2021</p>
      </ng-container>
      <ng-container *ngIf="entityType == 'IP'">
        <p>Institut PASTEUR - par <strong>Kaptitude</strong> - 2021</p>
      </ng-container>

    </div>
  </section>
</section>
